import React, { useContext, useState } from 'react'
import UserDetails from '../../context/UserDetails'
import Modal from '../modal/Modal'
import Loader from '../loader/Loader'

const LogoutModal = ({ show, onClose, setShowLogout }) => {

    const { setToken, setUser, initialState } = useContext(UserDetails)
    const [loader, setLoader] = useState(false)

    const handleLogout = () => {
        setShowLogout(false)
        setLoader(true)
        setTimeout(() => {
            setLoader(false)
            setToken("")
            setUser(initialState)
        },1500)
    }

    return (
        <React.Fragment>
            <Modal show={show} onClose={onClose} showClose={false}>
                <div className='my-3'>
                    <h4 className='font-bold'>Logout?</h4>
                    <p className='my-3'>Are you sure want logout?</p>
                </div>
                <div className='text-end'>
                    <button className='text-center p-2 link' onClick={handleLogout}>Yes</button>

                    <button className='text-center p-2 link' onClick={onClose}>No</button>
                </div>
            </Modal>
            <Loader show={loader} message={'Logging out'} overlay={true} />
        </React.Fragment>
    )
}

export default LogoutModal